import { IconButton, styled } from '@mui/material';

import { AircraftIcon, HubsCycleType, HubsIcon, HubsViewMode } from '#shared';

import { useAppDispatch } from '../../redux-store';
import { toolbarActions, toolbarSelectors } from '../../slices';

import { controlPanelClasses, MapControlPanel } from './MapControlPanel';

interface MapLayoutViewToggleProps {
  cycleType?: HubsCycleType;
}

const Root = styled(MapControlPanel)(({ theme: { spacing, breakpoints } }) => ({
  display: 'flex',
  height: spacing(5),
  [breakpoints.down('lg')]: { height: spacing(4) },
}));

export const MapLayoutViewToggle = ({
  cycleType = HubsCycleType.Base,
}: MapLayoutViewToggleProps) => {
  const dispatch = useAppDispatch();
  const hubsView = toolbarSelectors.useSelectHubsView();
  const showAircraftsOnFly = toolbarSelectors.useSelectShowAircraftsOnFly();
  const onHubsClick = () =>
    dispatch(toolbarActions.cycleHubsView({ cycleType }));
  const onAircraftClick = () =>
    dispatch(toolbarActions.toggleShowAircraftsOnFly());

  const isIconActive = hubsView === HubsViewMode.Hidden;

  return (
    <Root direction="row">
      <IconButton className={controlPanelClasses.button} onClick={onHubsClick}>
        <HubsIcon
          className={controlPanelClasses.icon}
          data-active={isIconActive}
        />
      </IconButton>

      <IconButton
        className={controlPanelClasses.button}
        onClick={onAircraftClick}
      >
        <AircraftIcon
          className={`${controlPanelClasses.icon} ${controlPanelClasses.aircraft}`}
          data-active={!showAircraftsOnFly}
        />
      </IconButton>
    </Root>
  );
};
